<!-- Navigation -->
<fuse-vertical-navigation
  class="dark bg-gray-900 print:hidden"
  [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="navigation.admin"
  [opened]="!isScreenSmall">
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationContentHeader>
    <div class="flex w-full items-center p-4 pl-6">
      <!-- Logo -->
      <div class="flex items-center justify-center">
        <img class="w-8" src="assets/images/logo/logo.svg" />
      </div>
      <!-- Components -->
      <div class="ml-auto flex items-center">
        <notifications />
        <user [showAvatar]="false" />
      </div>
    </div>
    <!-- User -->
    <div class="flex w-full flex-col items-center p-4">
      <div class="relative h-24 w-24">
        @if (user.avatar) {
          <img
            class="h-full w-full rounded-full"
            [src]="user.avatar"
            alt="User avatar" />
        }
        @if (!user.avatar) {
          <mat-icon
            class="icon-size-24"
          [svgIcon]="'heroicons_solid:user-circle'" />
        }
      </div>
      <div class="mt-6 flex w-full flex-col items-center justify-center">
        <div
          class="w-full overflow-hidden text-ellipsis whitespace-nowrap text-center font-medium leading-normal">
          {{ user.name }}
        </div>
        <div
          class="text-md text-secondary mt-0.5 w-full overflow-hidden text-ellipsis whitespace-nowrap text-center font-medium leading-normal">
          {{ user.email }}
        </div>
      </div>
    </div>
  </ng-container>
  <!-- Navigation footer hook -->
  <ng-container fuseVerticalNavigationContentFooter>
    <div
      class="flex-0 opacity-12 mb-4 mt-2 flex h-16 items-center justify-center pl-2 pr-6">
      <img class="max-w-36" src="assets/images/logo/logo-text-on-dark.svg" />
    </div>
  </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
  <!-- Header -->
  <div
    class="flex-0 z-49 bg-card relative flex h-16 w-full items-center px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none print:hidden md:px-6">
    <!-- Navigation toggle button -->
    <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
      <mat-icon [svgIcon]="'heroicons_outline:bars-3'" />
    </button>
    <!-- Components -->
    <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
      <languages />
      <fuse-fullscreen class="hidden md:block" />
      <search [appearance]="'bar'" />
      <shortcuts />
      <messages />
      <button class="lg:hidden" mat-icon-button (click)="quickChat.toggle()">
        <mat-icon [svgIcon]="'heroicons_outline:chat-alt-2'" />
      </button>
    </div>
  </div>

  <!-- Content -->
  <div class="flex flex-auto flex-col">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
    Otherwise, layout changes won't be registered and the view won't be updated! -->
    @if (true) {
      <router-outlet />
    }
  </div>

  <!-- Footer -->
  <!--<div class="relative flex print:hidden h-14 w-full items-center justify-start border-t px-4 flex-0 z-49 bg-card dark:bg-transparent md:px-6">
  <span class="font-medium text-secondary">Fuse &copy; {{currentYear}}</span>
</div>-->
</div>

<!-- Quick chat -->
<quick-chat #quickChat="quickChat" />
